import React from 'react';
import '../../../../styles/BreadCrumb.css';
import PropTypes from 'prop-types';

const BreadCrumb = ({ data, customClass }) => {
  return (
    <ul className={`rlBreadCrumb ${customClass ? customClass : ''}`}>
      {data &&
        data.length > 0 &&
        data.map(({ id, title, link }) => (
          <li key={id} className="rlBreadCrumb__item">
            <a href={link}>{title}</a>
          </li>
        ))}
    </ul>
  );
};

BreadCrumb.propTypes = {
  customClass: PropTypes.string,
  data: PropTypes.array
};

export default BreadCrumb;
